<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <div class="doc-paper preview rirekisho" :id="idPrefix + 'preview-page-01'">
      <div class="rirekisho-wapper">
        <div class="rirekisho-header" style="display: block">
          <div class="title text-center">志望動機書</div>
          <div
            class="date data text-right"
            :data-highlight="highlightMessage"
            @click="goCardTo('create-date')"
            :class="highLightClass('create-date')"
          >
            <span v-html="formatedCreateDate"></span>
          </div>

          <div
            class="data text-left"
            :data-highlight="highlightMessage"
            @click="goCardTo('letterprofile')"
            :class="highLightClass('letterprofile')"
          >
            <div class="postal-code" :style="formatData.selFontStyle">
              &#12306;{{ formLib.separatedPostNumber(basicData.postNumber) }}
            </div>
            <pre :style="formatData.selFontStyle"
              >{{ basicData.address1 }}{{ basicData.address2 }}</pre>
            <div class="name" :style="formatData.selFontStyle">
              {{ basicData.tel1 }}-{{ basicData.tel2 }}-{{ basicData.tel3 }}
            </div>
            <div
              class="name"
              :style="formatData.selFontStyle"
              v-if="basicData.email"
            >
              {{ basicData.email }}
            </div>
            <div class="name" :style="formatData.selFontStyle">
              {{ basicData.lastName }}&emsp;{{ basicData.firstName }}
            </div>
          </div>
        </div>

        <div class="rirekisho-content">
          <div
            class="input"
            :data-highlight="highlightMessage"
            @click="goCardTo('long_reason')"
            :class="highLightClass('long_reason')"
            style="
              border: 1px solid #000;
              padding: 5px;
              margin-top: 20px;
              height: 750px;
            "
          >
            <pre
              ref="longreason"
              :class="classObject.longreason"
              :style="formatData.selFontStyle"
              >{{ formatData.longreason }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useFormatPreview } from '@/composables/format-edit/useFormatPreview'
import { usePreviewOverflow } from '@/composables/format-edit/usePreviewOverflow'
import { formatPreviewCreateDate } from '@/utils/format-edit/previewDates'
import { useHostServices } from '@/composables/format-edit/useHostServices'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const { formLib } = useHostServices()
const { scaleStyle, highlightMessage, goCardTo, highLightClass } =
  useFormatPreview(props)

const longreason = ref<HTMLElement | null>(null)

const { classObject, adjustFontSize } = usePreviewOverflow({
  getEl: (name) =>
    name === 'longreason' ? (longreason.value ?? undefined) : undefined,
  maxHeights: { longreason: 750 },
  watchSources: [
    { name: 'longreason', source: () => props.formatData?.longreason }
  ]
})

const formatedCreateDate = computed(() =>
  formatPreviewCreateDate(
    props.formatData?.createDate,
    formLib.dateFormat,
    'placeholder'
  )
)

function checkValid() {
  adjustFontSize('longreason')
}

defineExpose({ checkValid })
</script>
